import * as helpers from './helpers';
import { Modal } from './lib/modal.ts';
import fixedElements from './toggleFIxedElements';

let instance;
const DOM = {};

const menuTemplate = helpers.parseHTML(
    '<div class="mobile-menu"><ul class="mobile-menu__list"></ul></div>'
);

const liTemplate = helpers.parseHTML(
    '<li class="mobile-menu__list-item"><button class="mobile-menu__next"></button><a class="mobile-menu__link"></a></li>'
);

// After some testing, rendering the menu from a string template is the fastest
// way to do this. Using <template> is inconsistent and creating all nodes
// programatically is ~15% slower.

// The item's properties have short names to save bandwidth
// item.n = Name
// item.u = Url
// item.c = Children

function drawMenu(list) {
    const frag = menuTemplate.cloneNode(true);
    const ul = frag.querySelector('ul');

    list.forEach((x) => {
        const li = liTemplate.cloneNode(true);
        const a = li.querySelector('a');
        const button = li.querySelector('button');

        a.textContent = x.n;
        a.href = x.u;

        if (x.c) {
            button.addEventListener(
                'click',
                helpers.throttle(drawMenu.bind(null, x.c), 500)
            );
        } else {
            li.removeChild(button);
        }

        ul.appendChild(li);
    });

    document.querySelector('#mm > div').appendChild(frag);
}

function removeLevels(wait = false) {
    const container = document.querySelector('#mm > div');
    const levels = [
        ...container.querySelectorAll(
            '.mobile-menu:not(.mobile-menu--closing)'
        ),
    ].slice(1);

    if (levels.length < 1) return;

    const handler = () =>
        levels.forEach((x) => {
            x.remove();
            container.removeEventListener('animationend', handler);
        });

    if (wait) {
        container.addEventListener('animationend', handler);
    } else {
        container.removeEventListener('animationend', handler);
        levels.forEach((x) => x.remove());
    }
}

function onMobileOpen() {
    DOM.logo.classList.add('nav__logo--hidden');
    DOM.nav.classList.add('nav--overlayed');
    DOM.navListItems.forEach((item) => {
        const link = item.firstElementChild;
        if (link !== DOM.openMenuElement) {
            item.classList.add('nav__listItem--hide');
        }
    });

    fixedElements.toggleNavModal();

    /* Check for IE as it doesnt let you change classes in svg elements */
    if (DOM.openMenuElement.firstElementChild.classList) {
        DOM.openMenuElement.firstElementChild.classList.add('svg-close');
    }

    removeLevels(false);
}

function onMobileClose() {
    DOM.logo.classList.remove('nav__logo--hidden');
    DOM.nav.classList.remove('nav--overlayed');
    DOM.navListItems.forEach((item) => {
        const link = item.firstElementChild;
        if (link !== DOM.openMenuElement) {
            item.classList.remove('nav__listItem--hide');
        }
    });

    fixedElements.toggleNavModal();

    /* Check for IE as it doesnt let you change classes in svg elements */
    if (DOM.openMenuElement.firstElementChild.classList) {
        DOM.openMenuElement.firstElementChild.classList.remove('svg-close');
    }

    removeLevels(true);
}

function init() {
    const mm = document.querySelector('#mm');

    if (!mm) return;

    DOM.openMenuElement = document.querySelector('.nav__link--open-menu');
    DOM.nav = document.querySelector('.nav');
    DOM.navListItems = document.querySelectorAll('.nav__listItem');
    DOM.backButton = document.querySelector('#mm button');
    DOM.logo = document.querySelector('.nav__logo');

    instance = Modal.init({
        modal: mm,
        openClasses: ['slide-modal--open'],
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        disableFocus: false,
        disableScroll: true,
        onShow: onMobileOpen,
        onClose: onMobileClose,
    });

    const menuJSON = JSON.parse(document.getElementById('menu').textContent);

    drawMenu(menuJSON);

    DOM.backButton.addEventListener('click', () => {
        const container = document.querySelector('#mm > div');
        const levels = container.querySelectorAll(
            '.mobile-menu:not(.mobile-menu--closing)'
        );

        if (levels.length <= 1) return;

        const last = levels[levels.length - 1];
        last.classList.add('mobile-menu--closing');
        last.addEventListener('animationend', () =>
            container.removeChild(last)
        );
    });
}

function getInstance() {
    return instance;
}

export default {
    init,
    getInstance,
    drawMenu,
    removeLevels,
};
